export const inputs = {
  login: "Логин",
  password: "Пароль",
  code: "Введите код",
};
